import { MARQUEE_ITEMS } from "@/config/homeContent";

// One slow editorial marquee. Duplicated track for a seamless loop;
// animation disabled under prefers-reduced-motion via index.css.
const Marquee = () => (
  <div
    data-testid="capabilities-marquee"
    aria-label={`Core capabilities: ${MARQUEE_ITEMS.join(", ")}`}
    className="relative overflow-hidden border-y border-brand-mist/10 bg-brand-charcoal/50 py-5"
  >
    <div className="flex w-max animate-marquee items-center">
      {[0, 1].map((copy) => (
        <div key={copy} aria-hidden={copy === 1} className="flex items-center">
          {MARQUEE_ITEMS.map((item) => (
            <span key={`${copy}-${item}`} className="flex items-center">
              <span className="whitespace-nowrap px-8 font-display text-sm font-medium uppercase tracking-[0.3em] text-brand-mist sm:text-base">
                {item}
              </span>
              <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-brand-emerald/60" />
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);

export default Marquee;
